import React from 'react';

//interfaces
import { IFormButtonElement, ValidationRules } from '../../../../interfaces/IFormElement';
import { IconLibrary } from '../../../../../../interfaces/icon/IconLibrary';

//components
import IconButton from '../../../../../global/buttons/IconButton';



const SubmitButtonDetails = ({submitButtonText, onEditClick, validationErrors, type}: {submitButtonText: string, onEditClick: ()=>void, validationErrors?: ValidationRules[], type:IFormButtonElement} ) => {
    const hasValidationErrors = (validationErrors?.length ?? 0) >= 1;
    
    return (
        <div className={`submit-button-details form-element-details-wrapper ${hasValidationErrors ? 'form-validation-errors' : ''}`}>
            <div className='form-element-type-details'>
                <h3 
                    className='form-element-label-text'
                    onClick={onEditClick}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onEditClick(); }}
                >
                    {submitButtonText}
                </h3>
                
                <span className='element-type-text'>{`(${type})`}</span>
            </div>

            <IconButton 
                ariaLabel={`Edit ${type} Text`} 
                className={'icon-button-squared control-button'} 
                iconName={IconLibrary.PENCIL} 
                onButtonClick={onEditClick}
            />
        </div>
    );
};

export default SubmitButtonDetails